<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { faMessageSmile } from '@fortawesome/duotone-regular-svg-icons'
import { useRoute } from '#imports'
import { pageTitle } from '~/utils/dom'
import useAuthStore from '~/stores/auth'
import { PendoFeature } from '~/models/Pendo'
import Tooltip from '~/components/ui/Tooltip.vue'
import Button from '~/components/ui/Button.vue'

const { t } = useI18n()
const route = useRoute()
const { isTeacher, userOrganization } = storeToRefs(useAuthStore())

const supportEmail = import.meta.env.VITE_SUPPORT_EMAIL
const newLine = '%0D%0A%0D%0A'

const showFeedbackButton = computed(() => isTeacher.value)
const subject = computed(() => t('reportFeedback.subject', { title: encodeURIComponent(pageTitle.value) }))
const bodyUrl = computed(() => t('reportFeedback.url', { url: encodeURIComponent(location.origin + route.fullPath) }))
const organizationMessage = computed(() => userOrganization.value ? t('reportFeedback.organization', { name: userOrganization.value.name, number: userOrganization.value.number }) : '')
const body = computed(() => `${t('reportFeedback.intro')}${newLine}${newLine}${t('reportFeedback.placeholder')}${newLine}${newLine}${bodyUrl.value}${newLine}${organizationMessage.value}${newLine}`)
const mailtoLink = computed(() => `mailto:${supportEmail}?subject=${subject.value}&body=${body.value}`)
</script>

<template>
  <Tooltip
    v-if="showFeedbackButton"
    :disabled="!!$slots.default?.().length"
    side="top"
    :content="t('reportFeedback.button')"
  >
    <Button
      :data-pendo="PendoFeature.Feedback.Button"
      v-bind="$attrs"
      :href="mailtoLink"
    >
      <font-awesome-icon :icon="faMessageSmile" />
      <slot />
    </Button>
  </Tooltip>
</template>
